import { instructorCoursesListActionTypes as types } from "Screens_old";
import initialState from "Store/InitialState";
import produce from "immer";
import log from "loglevel";

export function instructorCoursesMapReducer(
  state = initialState.instructorCoursesMap,
  action
) {
  let newState;
  switch (action.type) {

    case types.LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS:
      return action.instructorCoursesMap;

    case types.PUBLISH_COURSE_SUCCESS:
      let { courseId } = action;
      return produce(state, (draftState) => {
        log.log(draftState);
        draftState.filter((course) => {
          if (course.id === courseId) {
            course.is_published = !course.is_published;
            return course;
          }
          return course;
        });
      });

    case types.DELETE_COURSE_SUCCESS:
      return produce(state, (draftState) => {
        draftState = state.filter((course) => course.id !== action.courseId);
        return draftState;
      });

    case types.ADD_COURSE_SUCCESS:
      let { course } = action;
      return produce(state, (draftState) => {
        draftState.push(course);
      });

    // case types.IMPORT_COURSE_PROGRESS: {
    //   let { progress } = action;
    //   newState = new Map(state);
    //   log.log({ progress, newState });
    //   return state;
    // }

    case types.IMPORT_COURSE_SUCCESS: {
      newState = new Map(state);
      newState.set(action.course.id, action.course);
      return newState;
    }

    case types.DOWNLOAD_COURSE_SUCCESS:
      // newState = new Map(state);
      // let c = newState.get(action.courseId);
      // c.archive.progress = "Submitted";
      // newState.set(c.id, c);
      // return newState;
      return produce(state, (draftState) => {
        log.log(draftState);
        draftState.filter((course) => {
          if (course.id === action.courseId) {
            course.archive.progress = "Submitted";
            return course;
          }
          return course;
        });
      });

    case types.DELETE_ARCHIVE_SUCCESS:
      return produce(state, (draftState) => {
        log.log(draftState);
        draftState.filter((course) => {
          if (course.id === action.courseId) {
            course.archive.progress = "not_present";
            course.archive.active = null;
            course.archive.link = null;
            return course;
          }
          return course;
        });
      });

    case types.LOAD_ARCHIVE_STATUS_SUCCESS:
      // newState = new Map(state);
      // let crse = newState.get(action.resp.crseid);
      // crse.archive = action.resp.arch;
      // newState.set(crse.id, crse);
      // return newState;
      return produce(state, (draftState) => {
        log.log(draftState);
        draftState.filter((course) => {
          if (course.id === action.resp.crseid) {
            course.archive = action.resp.arch;
            return course;
          }
          return course;
        });
      });

    case types.DISABLE_ARCHIVE_SUCCESS:
      newState = [ ...state ];
      let disable_crse_index = newState?.findIndex?.(d => d.id === action.courseId);
      log.log({ disable_crse_index, action, state, newState })
      if (disable_crse_index >= 0) {
        newState[disable_crse_index].archive.active = !newState[disable_crse_index].archive.active;
      }
      return newState;
    default:
      return state;
  }
}

export function instructorInstituteListReducer(
  state = initialState.instituteList,
  action
) {
  switch (action.type) {
    case types.LOAD_INSTITUTE_LIST_SUCCESS:
      return action.instituteList;
    default:
      return state;
  }
}

export function instructorDepartmentListReducer(
  state = initialState.instituteList,
  action
) {
  switch (action.type) {
    case types.LOAD_DEPARTMENT_LIST_SUCCESS:
      return action.departmentList;
    default:
      return state;
  }
}

export function instructorImportCoursesListReducer(
  state = initialState.instructorImportCoursesList,
  action
) {
  switch (action.type) {
    case types.LOAD_IMPORT_COURSES_LIST_SUCCESS:
      return action.data;
    case types.ADD_COURSE_SUCCESS:
      if (state.length !== 0) {
        return [...state, action.course];
      }
      return state;
    case types.IMPORT_COURSE_SUCCESS:
      return [...state, action.course];
    default:
      return state;
  }
}

export function fileUploadProgressReducer(state = initialState.fileUploadProgress, action) {
  switch (action.type) {
    case types.IMPORT_COURSE_PROGRESS:
      return produce(state, (draftState) => {
        draftState.uploadProgress = action.progress;
        draftState.uploadRequestStatus = 'UPLOADING';
        if (action.progress?.includes?.('100')) {
          draftState.uploadProgress = '100.00';
          draftState.uploadRequestStatus = 'UPLOADED';
        }
      });

    case types.IMPORT_COURSE_PROGRESS_RESET:
      // log.log({action})
      return initialState.fileUploadProgress;

    default:
      return state;
  }
}